export var API_KEY = '70744d379f87a37df68a';
// TODO: Move to marvel-core?
// New content has been created
export var EVENT_CONTENT_CREATED = 'event_content_created';
// Existing content has been updated
export var EVENT_CONTENT_UPDATED = 'event_content_updated';
// A hotspot has been added or updated
export var EVENT_HOTSPOT = 'event_hotspot';
// ZIP dowload of assets has been created
export var EVENT_ASSESTS_ZIP_CREATED = 'event_assets_zip_created';
